import { putCollection } from '../api/collectionManager';
export const renameUserCollectionById = async (collectionId, collectionName, headers, logger) => {
    const body = {
        name: collectionName,
    };
    return putCollection(body, `collections/${collectionId}`, headers, logger);
};
